import { render } from "./Clients.vue?vue&type=template&id=be23c7da&scoped=true"
import script from "./Clients.vue?vue&type=script&lang=js"
export * from "./Clients.vue?vue&type=script&lang=js"

import "./Clients.vue?vue&type=style&index=0&id=be23c7da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-be23c7da"

export default script